import React from 'react'
import { Step, MultipleAnswer } from '../../components'

const GRADES = {
  key: 'teaches_grade',
  trackingKey: 'grades',
  question: 'What grades do you teach?',
  choices: [
    { text: 'Pre-K/K', value: 'kindergarten' },
    { text: 'Grades 1 to 3', value: 'grade_1_to_3' },
    { text: 'Grades 4 to 5', value: '4_to_5' },
    { text: 'Grades 6 to 8', value: '6_to_8' },
    { text: 'Grades 9 to 12', value: '9_to_12' },
    { text: 'Higher Education', value: 'higher_ed' },
    { text: 'Other', value: 'other' }
  ]
}

export const EducatorTeachedGrades = ({ index }) => {
  return (
    <Step
      index={index}
      itemsCount={GRADES.choices.length}
      mode='multiple'
      trackingKey={GRADES.trackingKey}
      title={GRADES.question}
      subtitle='Select all that apply (Required)'
    >
      {GRADES.choices.map(({ text, value }) => (
        <MultipleAnswer
          key={`${text}-${value}`}
          question={GRADES.question}
          surveyKey={GRADES.key}
          text={text}
          icon={null}
          value={value}
        />
      ))}
    </Step>
  )
}
